import axios from 'axios';

const WEBHOOK_URL = 'https://automatizacion.aigencia.ai/webhook/facial-recognition';

export const identifyUser = async (base64Image, webhookUrl = WEBHOOK_URL) => {
    try {
        const response = await axios.post(webhookUrl, { image: base64Image }, {
            headers: { 'Content-Type': 'application/json' }
        });
        return response.data;
    } catch (error) {
        console.error('Error calling facial recognition webhook:', error);
        throw error;
    }
};

export const addFace = async (base64Image, patientId, nombre, webhookUrl) => {
    const response = await axios.post(webhookUrl, { image: base64Image, patientId, nombre }, {
        headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
};

export const deleteFace = async (faceId, patientId, webhookUrl) => {
    const response = await axios.post(webhookUrl, { faceId, patientId }, {
        headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
};

export const listFaces = async (webhookUrl) => {
    const response = await axios.post(webhookUrl, {}, {
        headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
};
